import AppModel from '@/models/AppModel'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params, callback) => {
    return AppModel.get('item/search', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      return Promise.resolve(res.data)
    }, null, callback)
  }
}



// WEBPACK FOOTER //
// ./src/models/SearchItemModel.js